import React, { useState, useEffect } from "react";

const SingleProductDetailWhilePayingPopup = ({ cart_display }) => {
  return (
    <>
      <div className="modal fade" id="singleProductDetailWhilePayingModal" tabIndex="-1" aria-labelledby="singleProductDetailWhilePayingModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content">
            {/* <div className="modal-header">
              <h1 className="modal-title fs-5">What am I paying for?</h1>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div> */}
            <div className="modal-body text-center">
              {cart_display.length > 0 && cart_display.map((singleCartLineItem, index) => (
                <div className="singleProductCard" key={singleCartLineItem.cart_token}>
                  {singleCartLineItem.cart_token !== 'discount' && 
                    <div className="">
                      <div className="">
                        <img src={singleCartLineItem.image_link || "https://placehold.co/100"} className="productImage" />
                      </div>
                      <div className="">
                        <div className="">
                          <h5 className="mb-1">
                            {singleCartLineItem.name}
                          </h5>
                        </div>
                        <p className="note mt-2">
                          {singleCartLineItem.description}
                        </p>
                      </div>
                    </div>
                  }
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SingleProductDetailWhilePayingPopup;
